"use client";

import React, { useEffect, useState } from "react";
import { Menu, X, ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
function HeaderMenuConsumer({
  isMobileMenuOpen,
  onMobileItemClick
}: {
  isMobileMenuOpen: boolean;
  onMobileItemClick: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="hidden md:flex gap-4">
        <div className="h-4 w-16 bg-muted animate-pulse rounded-none" />
        <div className="h-4 w-16 bg-muted animate-pulse rounded-none" />
        <div className="h-4 w-16 bg-muted animate-pulse rounded-none" />
      </div>;
  }
  return <>
      <div className="hidden md:block relative group">
        <select className="appearance-none bg-background border-2 border-primary text-foreground font-serif uppercase tracking-widest text-xs px-6 py-2 pr-10 rounded-none cursor-pointer hover:bg-primary/10 transition-colors focus:outline-none focus:ring-2 focus:ring-primary/50" onChange={e => {
        if (e.target.value) window.location.href = e.target.value;
      }} defaultValue="">
          <option value="" disabled>Navigate Elite</option>
          {menuItems.map((item, i) => <option key={item.id} value={item.href || "#"} data-index={i}>
              {item.label}
            </option>)}
        </select>
        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 size-4 text-primary pointer-events-none" />
      </div>

      {isMobileMenuOpen && <nav className="absolute top-full left-0 w-full bg-background/95 backdrop-blur-lg border-b border-primary/20 flex flex-col p-4 shadow-2xl md:hidden">
          {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} onClick={onMobileItemClick} className="font-serif uppercase tracking-widest text-sm text-foreground py-4 border-b border-border/50 last:border-0 hover:text-primary transition-colors">
              {item.label}
            </Link>)}
        </nav>}
    </>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <section data-section-id="223901" id="header" className={`sticky top-0 z-50 w-full transition-all duration-300 bg-background text-foreground border-b-2 border-primary ${isScrolled ? "bg-background/80 backdrop-blur-lg border-primary/40 shadow-lg" : ""}`}>
      <MenuProvider menu_id="54">
        <div className="container mx-auto px-4 md:px-8 h-20 flex items-center justify-between relative">
          
          <div className="flex-1 flex items-center justify-start">
            <Button variant="ghost" size="icon" className="md:hidden text-foreground hover:bg-primary/10" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle navigation menu" aria-expanded={isMobileMenuOpen}>
              {isMobileMenuOpen ? <X className="size-5" /> : <Menu className="size-5" />}
            </Button>
            <HeaderMenuConsumer isMobileMenuOpen={isMobileMenuOpen} onMobileItemClick={() => setIsMobileMenuOpen(false)} />
          </div>

          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <Link to="/" className="flex items-center justify-center">
            </Link>
          </div>

          <div className="flex-1 flex items-center justify-end">
            <Button variant="ghost" className="font-serif uppercase tracking-widest text-xs bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300 hidden sm:inline-flex h-10 px-8 rounded-none font-semibold">
              Join Us
            </Button>
          </div>
          
        </div>
      </MenuProvider>
    </section>;
}